__turbopack_context__.v({
  "ns-logo": "PostsEntry-module-scss-module__kVxs4q__ns-logo",
  "posts-entry-excert": "PostsEntry-module-scss-module__kVxs4q__posts-entry-excert",
  "posts-entry-feature-image-container": "PostsEntry-module-scss-module__kVxs4q__posts-entry-feature-image-container",
  "posts-entry-title": "PostsEntry-module-scss-module__kVxs4q__posts-entry-title",
  "posts-entry-title-link": "PostsEntry-module-scss-module__kVxs4q__posts-entry-title-link",
});
